"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSpecError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "NoSpecError";
const messageKey = "driver.typespec.error.noSpecError";
class NoSpecError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey),
        });
    }
}
exports.NoSpecError = NoSpecError;
//# sourceMappingURL=noSpecError.js.map